import React, { useState, useEffect, useRef } from 'react';

import companyname from "../media/LOGO.png"
import heroimage from '../media/heroimage.png'
import kiwi from "../media/KIWI.jpg";
import market from "../media/Market.jpg";
import raspberry from "../media/Raspberry.jpg";
import trading from "../media/Trading.jpg";
import swayambhunath from "../media/Swaymbhunath.mp4"
import office1 from '../media/office1.png';
import office2 from '../media/office2.png';
import agrofarm from "../media/Brahma Jyoti Multi Agro Farm.png";
import greenenergy from "../media/Brahma Jyoti Green Energy.png";
import financial from "../media/Brahma Jyoti Investment & Equity Management.png";
import YadavBhattarai from "../media/ManagementTeam/YADAV BHATTARAI.png";
import UdeshKhadka from "../media/ManagementTeam/UDESH KHADKA.png";
import DineshKKhadka from "../media/ManagementTeam/DineshKKhadka.png";
import JibanNeupane from "../media/ManagementTeam/male.png";

// import {ReactComponent as AgricultureIcon} from "../icons/wheat-awn.svg"

import { Layout, Menu, Typography, Button, Row, Col, Card, Carousel, Flex } from 'antd';
import ManagementTeam from './ManagementTeam';

// import notice from "../media/Notices/notice2.png";
import shareNotice from "../media/Notices/sharesansarnotice.png";
import axios from 'axios';
import config from "../config.json"
// import apiKey from "../apikey.json"

const homeImages = [companyname,

  kiwi,
  market,
  raspberry,
  trading,
  office1,
  office2,
  agrofarm,
  greenenergy,
  financial,]


const { Header, Content, Footer } = Layout;
const { Title, Paragraph } = Typography;

const Home = () => {

  const [isVisible, setIsVisible] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [popupContent, setPopupContent] = useState<any>([])

  

  const targetRef = useRef(null);
  const POPUP_KEY = "popupSeenExpiry";
  function shouldShowPopup(ttl: number) {
    const stored = localStorage.getItem(POPUP_KEY);
    if (!stored) return true;

    const { expiry } = JSON.parse(stored);
    return Date.now() > expiry;
  }

  function markPopupSeen(ttl: number) {
    localStorage.setItem(
      POPUP_KEY,
      JSON.stringify({ expiry: Date.now() + ttl })
    );
  
  }
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      setIsVisible(entry.isIntersecting);
    });

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }



       getNotice();
      
    
 if (shouldShowPopup(60 * 60 * 1000)) {
    setShowPopUp(true);
    markPopupSeen(60 * 60 * 1000);
  }
    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current);
      }
    };


  }, []);

  const getNotice = async () => {
    try {
      const response = await axios.post(
        config.prodURL + "notices",

        {
          headers: {
            // "API-Key": apiKey.DJANGO_API_KEY,
            "Content-Type": "application/json",
          },
        }
      );
      //console.log("Response:", JSON.parse(response.data));  // Log all notices received
      var allNotices = (JSON.parse(response.data))
      var popUpContent = allNotices.filter((x: { showonpopup: boolean; }) => x.showonpopup === true);
      if (popUpContent.length == 0) {
        setShowPopUp(false);
      } else {
        setPopupContent(popUpContent[0])
       
      }



    } catch (error) {
      console.error("Error:", error);
    }
  }


  return (
    <div className='homepage'>
      {showPopUp && (
        <div className="overlay">
          <div className="popup" >
            <Row justify={'space-around'}>
              <h1 style={{ color: 'white', margin: 20, fontSize: '40px', textAlign: 'center' }}>Notice</h1>
              <button className="close-btn" onClick={() => { setShowPopUp(false); localStorage.setItem("showPopUp", "false")}}>X</button>
            </Row>


            <a href={popupContent.link} target="_blank" style={{ textDecoration: 'none', color: 'white', fontSize: '12px' }} >
              <h1 >{popupContent.name}</h1>
              <img className='notice-image' src={popupContent.attachment} alt="Popup notice" />
            </a>
          </div>
        </div>
      )}

      <div className="hero-section">
        <video autoPlay loop muted playsInline className="background-video" >
          <source src={swayambhunath} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <Row  >
          <Col className="translucent-box">




            <img src={companyname} alt="Slide 4" className="homeboximage" />
            <div className='information'>
              <p className="info-text" >
                Incorporated as a Public Limited Company under the Companies Act, 2063. The primary purpose of our company is to own and manage a portfolio of assets and investments, including shares in other companies, real estate, and intellectual property of our client's hard-earned money with the divine intention of multiplying them.
              </p>
              <div >
                <a href="/#/overview"><button className="learn-more-btn">Learn More</button></a>
                {/* <a href="/#/individual"><button className="learn-more-btn">Join Now</button></a> */}
                <a href="/#/contact"><button className="learn-more-btn">Contact Us</button></a>

              </div>
            </div>




          </Col>
        </Row>

      </div>
      <div className="banner-container">
        <div className="banner">
          {homeImages.map((img, i) => (
            <img key={i} src={img} alt={"Slide " + i} height={250} className="home-image" />
          ))}
          {homeImages.map((img, i) => (
            <img key={`duplicate-${i}`} src={img} alt={"Slide " + i} height={250} className="home-image" />
          ))}
        </div>

      </div>

      {/* <div className="services-section" >
        <div>
          <h1 className="cards-title">
            Our Investments
          </h1>
        </div>
        <div ref={targetRef}>
          <div style={{ opacity: isVisible ? 1 : 0, transition: 'opacity 3s' }}>
            <Row justify="center" gutter={[16, 16]} >

              <Col xs={24} sm={24} md={8}>
                <a href="/#/brahmajyotiagrofarm" style={{ textDecoration: 'none' }}>
                  <Card hoverable  >
                    <div style={{ textAlign: 'center' }}>
                      <img src={agrofarm} alt="agrofarm" width={200} />
                    </div>
                    <Title level={3}>Agro Farm</Title>
                    <Paragraph style={{ fontSize: "16px" }}>
                      Produce high-quality kiwi fruits and offer integrated livestock management solutions that boost efficiency, sustainability, and economic benefits for farmers and communities in Nepal.
                    </Paragraph>
                    <i>See more</i>
                  </Card>
                </a>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <a href="/#/brahmajyotigreenenergy" style={{ textDecoration: 'none' }}>
                  <Card hoverable>
                    <div style={{ textAlign: 'center' }}>
                      <img src={greenenergy} alt="greenenergy" width={200} />
                    </div>
                    <Title level={3}>Green Energy </Title>
                    <Paragraph style={{ fontSize: "16px" }}>
                      A leading force in Nepal renewable energy sector, dedicated to advancing sustainable power solutions through its specialized focus on commercial solar power and hydropower projects.
                    </Paragraph>
                    <i>See more</i>
                  </Card>
                </a>
              </Col>
              <Col xs={24} sm={24} md={8} >
                <a href="/#/brahmajyotifinancial" style={{ textDecoration: 'none' }}>
                  <Card hoverable>
                    <div style={{ textAlign: 'center' }}>
                      <img src={financial} alt="financial" width={190} />
                    </div>
                    <Title level={3}>Investment and Equity Management</Title>
                    <Paragraph style={{ fontSize: "16px" }}>
                      Support and facilitate financial growth and stability for each entity within the group by delivering tailored financial strategies, capital raising, and strategic advisory services.
                    </Paragraph>
                    <i>See more</i>
                  </Card>
                </a>
              </Col>

            </Row>
          </div>
        </div>
      </div> */}


      <div className="testimonial-section" >
        <h1 >
          Testimonials
        </h1>

        <Row gutter={[16, 16]} justify="center" >

          <Col xs={24} sm={12} md={8}>
            <a href="#/testimonials?from=YadavBhattarai">
              <Card hoverable className="profile-header">
                <img
                  src={YadavBhattarai}
                  alt="Profile"
                  className="profile-picture"
                />
                <Title level={3}>Yadav Bhattarai, Chairperson</Title>
                <Paragraph style={{ fontSize: "15px" }}>
                  As we look to the future, we remain committed to diversifying our portfolio further, enhancing operational efficiencies, and maintaining a clear focus on generating long-term value for our stakeholders. The strength of our team, the depth of our investments, and our commitment to responsible business practices will continue to drive our success in the years ahead.
                </Paragraph>
                <i>See more</i>
              </Card>
            </a>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <a href="#/testimonials?from=DineshKhadka">
              <Card hoverable className="profile-header">
                <img
                  src={DineshKKhadka}
                  alt="Profile"
                  className="profile-picture"
                />
                <Title level={3}>Dinesh Kumar Khadka, CEO</Title>
                <Paragraph style={{ fontSize: "17px" }}>
                  We extend our heartfelt gratitude to each of you for your continued trust and support. Your confidence in our vision and strategy inspires us to achieve greater heights as we work towards delivering sustained growth and value creation.

                </Paragraph>
                <i>See more</i>
              </Card>
            </a>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <a href="#/testimonials?from=JibanNeupane">
              <Card hoverable className="profile-header">
                <img
                  src={JibanNeupane}
                  alt="Profile"
                  className="profile-picture"
                />
                <Title level={3}>Jiban Neupane, Secretary</Title>
                <Paragraph style={{ fontSize: "17px" }}>
                  As the Company Secretary for Brahma Jyoti Holdings Limited, a leading investment and trading firm, my primary responsibility is to ensure that we operate within the framework of applicable laws and regulations. </Paragraph>
                <i>See more</i>
              </Card>
            </a>
          </Col>
        </Row>

      </div>

      {/* <div className='team-members'>
        <ManagementTeam />
      </div> */}

      <div className="home-contact">

        Ready to secure your financial future?
        <a href="#/individual">
          <button className='join-btn'>
            Join Now
          </button>
        </a>
      </div>

    </div>
  )
}


export default Home;